import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { DashboardService } from 'src/shared/services/dashboard.service';
import { format } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import HighchartsESM from 'highcharts/es-modules/masters/highcharts.src';
import { loadHighcharts } from '../../../../../shared/highcharts';

@Component({
    selector: 'app-dashboard-ucod',
    templateUrl: './dashboard-ucod.component.html',
    styleUrls: ['./dashboard-ucod.component.scss'],
})
export class DashboardUcodComponent implements AfterViewInit {
    @ViewChild('heatMap') heatMap: ElementRef;
    startDate: Date;
    endDate: Date;
    textBoxData: any = {
        percent: '0%',
        ratio: '0',
        date_now: null,
    };
    loadding: boolean = false;
    tableData: any;
    tableData_error: any;

    public Highcharts: typeof HighchartsESM | null = null;

    constructor(
        @Inject(MAT_DATE_FORMATS) private myFormats: any,
        private dateAdapter: DateAdapter<Date>,
        private dashboardService: DashboardService,
        private toastService: ToastrService
    ) {
        this.dateAdapter.setLocale('vi-VN');
        loadHighcharts().then(Highcharts => (this.Highcharts = Highcharts))
    }

    ngAfterViewInit() {
        this.generate();
    }

    generate() {
        this.genTextBox();
        this.genTable();
        this.genLine();
        this.genHeat();
    }

    reGenerate() {
        if (this.startDate && this.endDate) {
            const paramOnly = `?from=${format(this.startDate, 'yyyy-MM-dd')}&to=${format(
                this.endDate,
                'yyyy-MM-dd'
            )}`;
            this.genTextBox(paramOnly);
            this.genTable(paramOnly);
            this.genLine(paramOnly);

            this.genHeat(paramOnly);

            this.toastService.success('Thống kê thành công!', 'Thành công');
            return;
        }
        if ((this.startDate && !this.endDate) || (!this.startDate && this.endDate)) {
            this.toastService.error('Nhập đủ hoặc bỏ trống 2 trường để thống kê', 'Thất bại');
            return;
        }
        this.genTextBox();
        this.genTable();
        this.genLine();
        this.genHeat();
        this.toastService.success('Thống kê thành công!', 'Thành công');

        return;
    }
    startDateChanged(event: any) {
        this.startDate = event.value;
    }
    formatDateCus(date: any) {
        if (date === null) return format(new Date(), 'dd/MM/yyyy');
        const [y, m, d] = date.split('-');
        return `${d}/${m}/${y}`;
    }
    endDateChanged(event: any) {
        this.endDate = event.value;
    }
    genTextBox(param?: string) {
        this.loadding = true;

        this.dashboardService.ucodTextbox(param || '?from=&to=').subscribe((results: any) => {
            this.textBoxData = results;
            this.loadding = false;
        });
    }
    genTable(param?: string) {
        this.loadding = true;

        this.dashboardService.ucodTable(param || '?from=&to=').subscribe((results: any) => {
            // error: Response({'status': 'error', 'message': f'Không có dữ liệu từ ngày {from_date} đến ngày {to_date}'})
            if (results.status === 'error') {
                this.tableData_error = results.message;
                this.tableData = NaN;
            }
            else{
                this.tableData = results;
            }
            this.loadding = false;
        });
    }
    genLine(param?: string) {
        this.dashboardService.ucodLine(param || '?from=&to=').subscribe((results: any) => {
            this.Highcharts?.chart('ucod_line', {
                chart: {
                    zooming: {
                        type: 'x',
                    },
                },
                title: {
                    text: 'Biểu đồ đánh giá độ chính xác theo thời gian',
                    align: 'left',
                    style: {
                        fontFamily: 'Roboto',
                        fontWeight: 'bold',
                    },
                },
                subtitle: {
                    text:
                        document.ontouchstart === undefined
                            ? 'Nhấp và kéo để phóng to'
                            : 'Kéo để phóng to',
                    align: 'left',
                },
                xAxis: {
                    type: 'datetime',
                },
                yAxis: {
                    title: {
                        text: 'Độ chính xác',
                    },
                },
                legend: {
                    enabled: false,
                },
                plotOptions: {
                    area: {
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1,
                            },
                            stops: [
                                [0, this.Highcharts.getOptions().colors?.at(0)],
                                [
                                    1,
                                    this.Highcharts.color(this.Highcharts.getOptions().colors?.at(0) as any)
                                        .setOpacity(0)
                                        .get('rgba'),
                                ],
                            ],
                        },
                        marker: {
                            radius: 2,
                        },
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 1,
                            },
                        },
                        threshold: null,
                    },
                },

                series: [
                    {
                        type: 'area',
                        name: 'Tỉ lệ',
                        data: results,
                    },
                ],
            } as any);
        });
    }

    genHeat(param?: string) {
        this.dashboardService.ucodHeatMap(param || '?from=&to=').subscribe((results: any) => {
            this.Highcharts?.chart(this.heatMap.nativeElement, {
                chart: {
                    type: 'heatmap',
                    marginLeft: 40,
                    marginRight: 100,
                    marginBottom: 85,
                    marginTop: 100,
                    height: results[0].height,
                    width: results[0].width,
                },
                title: {
                    text: results[0].title,
                    style: {
                        fontFamily: 'Arial',
                        fontSize: '18px'
                    }
                },
                xAxis: {
                    categories: results[0].x
                },
                yAxis: {
                    categories: results[0].y
                },
                colorAxis: {
                    min: 0,
                    minColor: '#ffffff',
                    maxColor: '#0000ff',
                },
                legend: {
                    align: 'right',
                    layout: 'vertical',
                    itemStyle: {
                        color: '#ff0000',
                    },
                    margin: 0,
                    verticalAlign: 'middle',
                    symbolHeight: results[0].height / 2
                },
                tooltip: {
                    formatter: function (tooltip) {
                        return '<b>Dự đoán: </b>' + this.series.xAxis.categories[this.point.x] + '<br>' + '<b>Thực tế: </b>' + this.series.yAxis.categories[this.point.y as number];
                    }
                },
                series: [{
                    name: "UCOD Confusion Matrix",
                    borderWidth: 1,
                    data: this.getSeries(results[0].z),
                    dataLabels: {
                        enabled: true,
                        style: {
                            color: '#000',
                            height: 16
                        }
                    },
                    type: 'heatmap'
                }]
            })
        })
    }

    private getSeries(z: number[][]): number[][] {
        let series = [];
        for (let i: number = 0; i < z.length; i++) {
            for (let j: number = 0; j < z[i].length; j++) {
                series.push([i, j, z[i][j]]);
            }
        }
        return series;
    }
}
